import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    http
      .post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      })
      .catch((e) => {
        toast.error(formatError(e));
        setUser(false);
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return null;
}
